import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
import { applyPost } from '@/api/organization.js';
import { mapActions } from 'vuex';
export default {
  components: {},
  data: function data() {
    var checkMobile = function checkMobile(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        var reg = /^1[1|0|1|2|3|4|5|6|7|8|9][0-9]\d{8}$/;

        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };

    return {
      dialogTitle: '欢迎试用有台智能仓储管理系统YTIMS',
      dialogVisible: false,
      loading: false,
      form: {
        organizationId: null,
        manuId: null,
        companyName: null,
        userName: null,
        mobile: null,
        mark: null
      },
      formRules: {
        manuId: [{
          required: true,
          message: '请输入公司名称',
          trigger: ['blur', 'change']
        }],
        userName: [{
          required: true,
          message: '请输入您的称呼',
          trigger: ['blur', 'change']
        }],
        mobile: [{
          required: true,
          message: '请输入您的手机号',
          trigger: ['blur', 'change']
        }, {
          validator: checkMobile,
          trigger: ['blur', 'change']
        }]
      },
      distributorList: [],
      imgList: ['1.jpg', '2.jpg'],
      profile: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/db', ['database', 'databaseClear'])), {}, {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, db;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.dialogVisible = true;
                that.distributorList = [];
                _context.next = 5;
                return _this.database({
                  user: true
                });

              case 5:
                db = _context.sent;
                that.profile = db.get('profile').value();
                that.form.organizationId = Number(that.profile.organizationId);
                _context.next = 10;
                return listDealerUserManufacturer({
                  page: 1,
                  pageSize: 9999
                }).then(function (res) {
                  that.distributorList = res.list;
                }).catch(function (e) {});

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.dialogVisible = false;
    },
    formSubmit: function formSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, form, findRow;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this2;
                form = JSON.parse(JSON.stringify(that.form));
                findRow = that.distributorList.find(function (item) {
                  return item.ID === form.manuId;
                });

                if (findRow) {
                  form.companyName = findRow.name;
                }

                console.log('form', form);

                _this2.$refs.form.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid, err) {
                    var item;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 14;
                              break;
                            }

                            that.loading = true;
                            _context2.prev = 2;
                            _context2.next = 5;
                            return applyPost(form);

                          case 5:
                            that.$notify.success('申请成功');
                            that.dialogClose();
                            _context2.next = 11;
                            break;

                          case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2["catch"](2);

                          case 11:
                            that.loading = false;
                            _context2.next = 21;
                            break;

                          case 14:
                            _context2.t1 = regeneratorRuntime.keys(err);

                          case 15:
                            if ((_context2.t2 = _context2.t1()).done) {
                              _context2.next = 21;
                              break;
                            }

                            item = _context2.t2.value;

                            _this2.$message.error(err[item][0].message);

                            return _context2.abrupt("return");

                          case 21:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[2, 9]]);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  })
};